export interface Zpr {
  CZPRGRUPO: string;
  CZPRCHAVE: string;
  CZPRGENERI: string;
  CZPRDESC: string;
  CZPRCOMPLE: string;
  NZPRRECNO: number;
}

export interface ZprList {
  items: Array<Zpr>;
}

export const getZprDefault = (): Zpr => {
  return{
    CZPRGRUPO: '',
    CZPRCHAVE: '',
    CZPRGENERI: '',
    CZPRDESC: '',
    CZPRCOMPLE: '',
    NZPRRECNO: 0,
  };
};


